import { render, staticRenderFns } from "./GoogleRedirect.vue?vue&type=template&id=33cc2a39&"
import script from "./GoogleRedirect.vue?vue&type=script&lang=js&"
export * from "./GoogleRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports